import { onAddToCart as onAddToCartService } from '../services/cart';
import { isFinalSale, isUnreturnable } from "../utils/product"
const GRAPHQL_URL = 'https://bugatchi-group-inc.myshopify.com/api/2023-07/graphql.json'

export class ProductCard {
  constructor(productCardEl, isRebuy=false) {
    this.state = {
      elements: {},
      tabletMedia: window.matchMedia('screen and (max-width: 1024px)'),
      isRebuy,
      status: "ready" // 'adding', 'ready'
    }
    if (
      !window?.products?.[productCardEl?.dataset?.id]  || 
      productCardEl.classList.contains('initialized')
    ) {
      return null;
    }
    productCardEl.classList.add('initialized')
    this.cacheState(productCardEl)
    this.addEventListeners()
  }

  cacheState(productCardEl) {
    const id = productCardEl.dataset.id;
    const product = window.products[id]
    this.state.elements = {
      ...this.state.elements,
      card: productCardEl,
      body: productCardEl.querySelector('.product-item__body'),
      video: productCardEl.querySelector('.product-item__media--video'),
      cartBtn: productCardEl.querySelector('.product-item__cart-btn'),
      cartBtnLabel: productCardEl.querySelector('.product-item__cart-btn span.short'),
      link: productCardEl.querySelector('.product-item__link')
    }

    this.state.product = {
      ...product,
      options: this.getProductOptions(id),
      selectedVariant: product.variants.length == 1 ? product.variants[0] : null,
      isAvailable: productCardEl.dataset.available === "true"
    } 
  }

  addEventListeners() {
    this.addVideoEventListeners();
    this.addCartBtnEventListeners();
    this.el.link.addEventListener('click', this.handleProductClick.bind(this))
  }

  get el() {
    return this.state.elements
  }

  get product() {
    return this.state.product
  }

  // Methods for product video

  onVideoPlay() {
    this.el.card.classList.add('playing');
  };
  
  onVideoPause() {
    this.el.card.classList.remove('playing');
  };

  isVideoPlaying() {
    return (
      this.el.video.currentTime > 0
      && !this.el.video.paused
      && !this.el.video.ended
      && this.el.video.readyState > this.el.video.HAVE_CURRENT_DATA
    )
  };
  
  playVideo() {
    if (!this.isVideoPlaying() && !this.state.tabletMedia.matches) {
      this.el.video.play();
    }
  };

  pauseVideo() {
    if (this.state.tabletMedia.matches) return;
    this.el.video.pause();
  };
  
  addVideoEventListeners() {
    if (!this.el.video) return;
    this.el.body.addEventListener('mouseenter', this.playVideo.bind(this))
    this.el.body.addEventListener('mouseleave', this.pauseVideo.bind(this))
    this.el.video.addEventListener('contextmenu', e => e.preventDefault())
    this.el.video.addEventListener('play', this.onVideoPlay.bind(this));
    this.el.video.addEventListener('pause', this.onVideoPause.bind(this));
  }

  // Methods for product toolbar

  getProductOptions(id) {
    const options = window.products[id].options
    options.splice(options.findIndex(option => option.name == "Color"), 1)
    return options
  }

  async getCartItems() {
    const id = this.product.selectedVariant.id;
    const quantity = 1;
    let price = this.product.selectedVariant.price / 100;
    let compare_at_price = this.product.selectedVariant.compare_at_price / 100;
    const sku = this.product.selectedVariant.sku.split('-')[1];
    const isCartPage = (/cart/i).test(document.body.dataset.templateName);
    const isRebuy = this.state.isRebuy;
    const rebuyProperties = {
      _source: 'Rebuy',
      _widget_id: isCartPage ? 16874 : 17054,
      _attribution: isCartPage
        ? 'Rebuy Cart'
        : 'Rebuy Product Page'
    };

    if (window.Shopify.currency.active !== "USD") {
      const query = `
        query {
          node(id: "gid://shopify/ProductVariant/${this.product.selectedVariant.id}") {
            ... on ProductVariant {
              priceV2 {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
            }
          }
        }
      `;
  
      try { 
        const response = await fetch(GRAPHQL_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": 'ec8327db27d6cc7c87157bb7b77a92cb',
          },
          body: JSON.stringify({ query }),
        });
        const { data } = await response.json();
        price = data.node?.priceV2?.amount;
        compare_at_price = data.node?.compareAtPrice?.amount;
      } catch (error) {
        console.log(error);
      }
    }

    let finalSale = isFinalSale(+price, +compare_at_price) || isUnreturnable(this.product);

    return [{        
      id,
      quantity,
      properties: {
        _OriginalPrice: `$${(+price).toFixed(2)}`,
        ...(compare_at_price && {_CompareAtPrice: `$${(+compare_at_price).toFixed(2)}`}),
        _ProductSku: sku,
        ...(isRebuy ? rebuyProperties : {}),
        ...(finalSale && { _finalSale: 'Final Sale', _LPROP: 'Final Sale' }),
        _productTitle: this.product.title
      }
    }]
  }

  get toolbarActive() {
    return this.el.body.classList.contains('active')
  }

  set toolbarActive(status=true) {
    this.el.body.classList.toggle('active', status);
    return this.el.body.classList.contains('active')
  }

  clearSelectedVariant() {
    this.product.selectedVariant = null
    this.product.options.forEach(option => option.selectedValue = null)
    this.el.card.querySelectorAll('.product-item__dropdown__item[data-value]')
      .forEach(option => option.classList.remove('active'))
    this.toolbarActive = false
  }

  setAddToCartLabel(label, fallbackLabel=null) {
    if (this.el.cartBtnLabel) {
      this.el.cartBtnLabel.textContent = label
    }
    if (!fallbackLabel) return;
    this.el.cartBtn?.classList.add("active");
    this.toolbarActive = false
    setTimeout(() => {
      this.el.cartBtn?.classList.remove("active");
      if (this.el.cartBtnLabel) {
        this.el.cartBtnLabel.textContent = fallbackLabel;
      }
    }, 2000)
  }

  async onAddToCart() {
    if (this.state.status === 'adding') return;
    if (!this.toolbarActive) {
      this.toolbarActive = true;
      this.setAddToCartLabel('Add')
      if (this.product.variants.length > 1) return
    }

    const allOptionsSelected = this.product.options.every(option => Boolean(option.selectedValue))
    if (!allOptionsSelected) {
      const unselectedOption = this.product.options.find(option => !option.selectedValue).name;
      this.setAddToCartLabel(`Please pick a ${unselectedOption}`, 'Add');
      return
    }

    this.state.status = 'adding';
    this.setAddToCartLabel("Adding...");
    this.el.cartBtn?.classList.add("active");
    this.toolbarActive = false;
    const items = await this.getCartItems();

    try {
      const response = await onAddToCartService(items, this.product.selectedVariant);
      const message = response?.message || "Added"
      this.setAddToCartLabel(message, "Add");
      this.clearSelectedVariant()
      
    } catch (er) {
      this.setAddToCartLabel('Please, try again', "Add");
      console.log(er);
    } finally {
      this.state.status = 'ready';
    }
  }

  getSelectedVariant() {
    this.product.selectedVariant = this.product.variants.find(variant => {
      return this.product.options.every(option => {
        return (
          !option.selectedValue || 
          variant[`option${option.position}`]?.toUpperCase() === 
          option.selectedValue?.toUpperCase()
        )
      })
    })
  }

  updateProductUrl() {
    if (!this.product.selectedVariant) return;
    Array.from(this.el.card.querySelectorAll('a')).forEach(el => {
      const url = new URL(el.href);
      const params = new URLSearchParams(url.search);
      params.set('variant', this.product.selectedVariant.id);
      url.search = params.toString();
      el.setAttribute('href', `${url.pathname}${url.search}`);
    });
  }

  onSelectOption(index, optionEls, e) {
    if (e.target.classList.contains('disabled')) return;
    const selectedValue = e.target.dataset.value
    if (!selectedValue) return;
    const selectedOption = this.product.options.find(option => option.position == index)
    selectedOption.selectedValue = selectedValue
    optionEls.querySelectorAll('[data-value]').forEach(option => option.classList.remove('active'))
    e.target.classList.add('active')
    this.setAddToCartLabel(`Add`)
    this.getSelectedVariant()
    this.updateProductUrl()
  }

  addCartBtnEventListeners() {
    if (!this.product.isAvailable) return;
    this.el.cartBtn?.addEventListener('click', this.onAddToCart.bind(this))
    this.el.card.querySelectorAll('[data-product-option]').forEach(option => {
      option.addEventListener(
        'click', 
        this.onSelectOption.bind(this, option.dataset.optionIndex, option))
    })
    this.el.card
      .querySelectorAll('.product-item__backdrop')
      .forEach(b => b.addEventListener('click', () => {
        this.el.body.classList.remove('active');
        this.setAddToCartLabel('Add')
      }))
  }

  // Other methods

  handleProductClick (e) {
    e.preventDefault();
    const productUrl = e.currentTarget.getAttribute('href');
    sessionStorage.setItem('plpHistory:product', this.product.id);
    sessionStorage.setItem('plpHistory:collection', window.Collection?.handle);
    window.location.href = productUrl;
  }
}
